import { useCallback, useEffect, useState } from 'react';

import { useLoginState } from '@xing-com/crate-hooks-use-login-state';

export const useDisplayAds = (): { displayAdsAllowed: boolean } => {
  const { isLoggedOut } = useLoginState();
  const [cmpInitialized, setCmpInitialized] = useState(false);

  const displayAdsAllowed = isLoggedOut && cmpInitialized;

  const handleCmpInitializeEvent = useCallback((): void => {
    setCmpInitialized(true);
  }, []);

  useEffect(() => {
    globalThis.addEventListener('UC_UI_INITIALIZED', handleCmpInitializeEvent);

    return () => {
      globalThis.removeEventListener(
        'UC_UI_INITIALIZED',
        handleCmpInitializeEvent
      );
    };
  }, [handleCmpInitializeEvent]);

  return {
    displayAdsAllowed,
  };
};
